import * as actions from './actions';
import mutations from './mutations';
import * as getters from './getters';

const state = {
    lastTimestamp: 0,
    isNeedUpdateEmail: null,
    isNeedUpdateActivity: null,
    isNeedUpdateImages: null,
    isNeedUpdateFiles: null,
    isNeedUpdateTask: null,
    isNeedUpdateDashboard: null,
};

export default {
    namespaced: true,
    mutations,
    actions,
    state,
    getters,
};
